import { createServerFn } from "@tanstack/react-start";

import type { ResultData } from "./metadata";

export interface StationSnapshot {
  data: ResultData[] | null;
  fetchedAt: number | null;
}

export const getStreamMetadata = createServerFn({ method: "GET" }).handler(
  async (): Promise<ResultData[]> => {
    const { fetchFromApi } = await import("./api-server");

    try {
      const response = await fetchFromApi("/api/public/station");
      if (!response.ok) {
        return [];
      }
      const snapshot = (await response.json()) as StationSnapshot;
      return snapshot.data ?? [];
    } catch {
      return [];
    }
  }
);
